import React from 'react'
import {useRoutes} from "react-router-dom"
import BaseLayout from '@/layouts/BaseLayout'
import LazyLoading from '@/components/LazyLoading'
import ErrorBoundary from './ErrorBoundary'

const lazyload = (path) => {
    let Com = React.lazy(() => {
        return new Promise(resolve => {
            setTimeout(() => {
               
                import(`../pages/${path}`).then(module => {
                    resolve(module);
                })
            }, /\/pages\/OrderManage\//.test(path) ? 0 : 0); // 设置延时为1000毫秒
        });
        // return import (`../pages/${path}`)
    })
    return (
        <ErrorBoundary>
            <React.Suspense fallback={<LazyLoading/>}>
                <Com/>
            </React.Suspense>
        </ErrorBoundary>
    )
}

const routes = [
    {
        path: '/product/detail/preview',
        element: lazyload('Product/FxsDetailPreview')
    },
    {
        path: '/',
        element: <BaseLayout/>,
        children: [
            {
                path: '/',
                element: lazyload('Home')
            },
            {
                path: '/video/detail',
                element: lazyload('Home/VideoDetail')
            }, {
                path: '/video',
                element: lazyload('Home/Video')
            }, {
                path: '/center',
                element: lazyload('UserCenter'),
                children: [
                    {
                        path: '/center/fxsorder',
                        element: lazyload('UserCenter/pages/OrderManage/FxsOrder'),
                    },
                    {
                        path: '/center/jxsorder',
                        element: lazyload('UserCenter/pages/OrderManage/JxsOrder'),
                    },
                    {
                        path: '/center/xsorder',
                        element: lazyload('UserCenter/pages/OrderManage/XsOrder'),
                    },
                    {
                        path: '/center/msorder',
                        element: lazyload('UserCenter/pages/OrderManage/MsOrder'),
                    },
                    {
                        path: '/center/jxscgorder',
                        element: lazyload('UserCenter/pages/OrderManage/JxscgOrder'),
                    },
                    {
                        path: '/center/khthdorder',
                        element: lazyload('UserCenter/pages/OrderManage/KhthdOrder'),
                    },
                    {
                        path: '/center/qtthdorder',
                        element: lazyload('UserCenter/pages/OrderManage/QtthdOrder'),
                    },
                    {
                        path: '/center/kc/sscxkc',
                        element: lazyload('UserCenter/pages/KcManage/Sscxkc'),
                    },
                    {
                        path: '/center/kc/kcbhbb',
                        element: lazyload('UserCenter/pages/KcManage/Kcbhbb'),
                    },
                    {
                        path: '/center/dcthdorder',
                        element: lazyload('UserCenter/pages/OrderManage/DcthdOrder'),
                    },
                    {
                        path: '/center/xsck',
                        element: lazyload('UserCenter/pages/InventoryManage/XsckManage'),
                    },
                    {
                        path: '/center/rkmx',
                        element: lazyload('UserCenter/pages/InventoryManage/Rkmx'),
                    },
                    {
                        path: '/center/dccprkd',
                        element: lazyload('UserCenter/pages/InventoryManage/Dccprkd'),
                    },
                    {
                        path: '/center/productmanage',
                        element: lazyload('UserCenter/pages/ProductManage/Dccpgl'),
                    },
                    {
                        path: '/center/productmanage/qtcpgl',
                        element: lazyload('UserCenter/pages/ProductManage/Qtcpgl'),
                    },
                    {
                        path: '/center/productmanage/cpdlgl',
                        element: lazyload('UserCenter/pages/ProductManage/Cpdlgl'),
                    },
                    {
                        path: '/center/base/staff',
                        element: lazyload('UserCenter/pages/BaseManage/StaffManage'),
                    },
                    {
                        path: '/center/base/fxsarchive',
                        element: lazyload('UserCenter/pages/BaseManage/FxsArchive'),
                    },
                    {
                        path: '/center/base/fzmjfxsarchive',
                        element: lazyload('UserCenter/pages/BaseManage/FzmjfxsArchive'),
                    },
                    {
                        path: '/center/productmanage/mjtzd',
                        element: lazyload('UserCenter/pages/ProductManage/Mjtzd'),
                    },
                    {
                        path: '/center/productmanage/khzkl',
                        element: lazyload('UserCenter/pages/ProductManage/Khzkl'),
                    },
                    {
                        path: '/center/productmanage/khzklys',
                        element: lazyload('UserCenter/pages/ProductManage/KhzklYs'),
                    },
                    {
                        path: '/center/productmanage/khcpjggl',
                        element: lazyload('UserCenter/pages/ProductManage/Cpjggl'),
                    },
                    {
                        path: '/center/productmanage/qtpp',
                        element: lazyload('UserCenter/pages/ProductManage/Qtpp'),
                    },
                    {
                        path: '/center/base/staffrole',
                        element: lazyload('UserCenter/pages/BaseManage/StaffRole'),
                    },
                    {
                        path: '/center/kcmanage/cpcfsz',
                        element: lazyload('UserCenter/pages/KcManage/Cpcfsz'),
                    },
                    {
                        path: '/center/kcmanage/cphbsz',
                        element: lazyload('UserCenter/pages/KcManage/Cphbsz'),
                    },
                    {
                        path: '/center/kcmanage/cpcfd',
                        element: lazyload('UserCenter/pages/KcManage/Cpcfd'),
                    },
                    {
                        path: '/center/kcmanage/cpcfhbd',
                        element: lazyload('UserCenter/pages/KcManage/Cpcfhbd'),
                    },
                    {
                        path: '/center/kcmanage/cpyfcgj',
                        element: lazyload('UserCenter/pages/KcManage/Cpyfcgj'),
                    },
                    {
                        path: '/center/kcmanage/pdd',
                        element: lazyload('UserCenter/pages/KcManage/Pdd'),
                    },
                    {
                        path: '/center/base/supplier',
                        element: lazyload('UserCenter/pages/BaseManage/SupplierManage'),
                    },
                    {
                        path: '/center/base/logisticscompany',
                        element: lazyload('UserCenter/pages/BaseManage/LogisticsCompanyManage'),
                    },
                    {
                        path: '/center/base/qtkhgl',
                        element: lazyload('UserCenter/pages/BaseManage/Qtkhgl'),
                    },
                    {
                        path: '/center/base/shdzgl',
                        element: lazyload('UserCenter/pages/BaseManage/Shdzgl'),
                    },
                    {
                        path: '/center/base/warehouse',
                        element: lazyload('UserCenter/pages/BaseManage/WarehouseManage'),
                    },
                    {
                        path: '/center/base/kwxx',
                        element: lazyload('UserCenter/pages/BaseManage/KwxxManage'),
                    },
                    {
                        path: '/center/base/xlxx',
                        element: lazyload('UserCenter/pages/BaseManage/XlxxManage'),
                    },
                    {
                        path: '/center/base/dcmbmanage',
                        element: lazyload('UserCenter/pages/BaseManage/DcmbManage'),
                    },
                    {
                        path: '/center/base/myinfo',
                        element: lazyload('UserCenter/pages/BaseManage/MyInfo'),
                    },
                    {
                        path: '/center/base/mysetting',
                        element: lazyload('UserCenter/pages/BaseManage/MySetting'),
                    },
                    {
                        path: '/center/kcmanage/cpdbd',
                        element: lazyload('UserCenter/pages/KcManage/Cpdbd'),
                    },
                    {
                        path: '/center/kcmanage/kcyjsz',
                        element: lazyload('UserCenter/pages/KcManage/Kcyjsz'),
                    },
                    {
                        path: '/center/kcmanage/kcqhcx',
                        element: lazyload('UserCenter/pages/KcManage/Kcqhcx'),
                    },
                    {
                        path: '/center/collaboration/qplddcx',
                        element: lazyload('UserCenter/pages/Collaboration/Qplddcx'),
                    },
                    {
                        path: '/center/collaboration/sdgjddcx',
                        element: lazyload('UserCenter/pages/Collaboration/Sdgjddcx'),
                    },
                    {
                        path: '/center/collaboration/zmdddcx',
                        element: lazyload('UserCenter/pages/Collaboration/Zmdddcx'),
                    },
                    {
                        path: '/center/collaboration/qpldddrxd',
                        element: lazyload('UserCenter/pages/Collaboration/Qpldddrxd'),
                    },
                    {
                        path: '/center/collaboration/sdgjdddrxd',
                        element: lazyload('UserCenter/pages/Collaboration/Sdgjdddrxd'),
                    },
                    {
                        path: '/center/collaboration/qplddmxb',
                        element: lazyload('UserCenter/pages/Collaboration/Qplddmxb'),
                    },
                    {
                        path: '/center/collaboration/sdgjddmxb',
                        element: lazyload('UserCenter/pages/Collaboration/Sdgjddmxb'),
                    },
                    {
                        path: '/center/collaboration/zmdddmxb',
                        element: lazyload('UserCenter/pages/Collaboration/Zmdddmxb'),
                    },
                    {
                        path: '/center/collaboration/receive',
                        element: lazyload('UserCenter/pages/Collaboration/ReceiveList'),
                    },
                    {
                        path: '/center/collaboration/received',
                        element: lazyload('UserCenter/pages/Collaboration/ReceivedList'),
                    },
                    {
                        path: '/center/collaboration/receivedtyd',
                        element: lazyload('UserCenter/pages/Collaboration/ReceivedTydList'),
                    },
                    {
                        path: '/center/collaboration/receivereport',
                        element: lazyload('UserCenter/pages/Collaboration/ReceiveReport'),
                    },
                    {
                        path: '/center/collaboration/qyzjxht',
                        element: lazyload('UserCenter/pages/Collaboration/Qyzjxht'),
                    },
                    {
                        path: '/center/collaboration/qyzbcxy',
                        element: lazyload('UserCenter/pages/Collaboration/Qyzbcxy'),
                    },
                    {
                        path: '/center/collaboration/qyzdzd',
                        element: lazyload('UserCenter/pages/Collaboration/QyzDzd'),
                    },
                    {
                        path: '/center/collaboration/qyzyddzd',
                        element: lazyload('UserCenter/pages/Collaboration/QyzYdDzd'),
                    },
                    {
                        path: '/center/collaboration/qyzshqrh',
                        element: lazyload('UserCenter/pages/Collaboration/QyzShqrh'),
                    },
                    {
                        path: '/center/collaboration/jxshqrhk',
                        element: lazyload('UserCenter/pages/Collaboration/JxShqrhk'),
                    },{
                        path: '/center/collaboration/qyzydshqrh',
                        element: lazyload('UserCenter/pages/Collaboration/QyzYdShqrh'),
                    },{
                        path: '/center/collaboration/gdydshqrh',
                        element: lazyload('UserCenter/pages/Collaboration/GdYdShqrh'),
                    },
                    {
                        path: '/center/collaboration/jxhtk',
                        element: lazyload('UserCenter/pages/Collaboration/Jxhtk'),
                    },
                    {
                        path: '/center/collaboration/bcxyk',
                        element: lazyload('UserCenter/pages/Collaboration/Bcxyk'),
                    },
                    {
                        path: '/center/collaboration/jxdzdk',
                        element: lazyload('UserCenter/pages/Collaboration/Jxdzdk'),
                    },
                    {
                        path: '/center/collaboration/jxyddzdk',
                        element: lazyload('UserCenter/pages/Collaboration/JxYddzdk'),
                    },
                    {
                        path: '/center/collaboration/dzd',
                        element: lazyload('UserCenter/pages/Collaboration/Dzd'),
                    },
                    {
                        path: '/center/collaboration/dcflcx',
                        element: lazyload('UserCenter/pages/Collaboration/Dcflcx'),
                    },
                    {
                        path: '/center/collaboration/yddzd',
                        element: lazyload('UserCenter/pages/Collaboration/Yddzd'),
                    },
                    {
                        path: '/center/collaboration/integraldetail',
                        element: lazyload('UserCenter/pages/Collaboration/IntegralProductDetail'),
                    },
                    {
                        path: '/center/collaboration/myintegraldetail',
                        element: lazyload('UserCenter/pages/Collaboration/MyIntegralDetail'),
                    },
                    {
                        path: '/center/collaboration/myintegraljf',
                        element: lazyload('UserCenter/pages/Collaboration/MyIntegralJfView'),
                    },
                    {
                        path: '/center/collaboration/sdfpreport',
                        element: lazyload('UserCenter/pages/Collaboration/SdfpReport'),
                    },
                    {
                        path: '/center/collaboration/jhdreport',
                        element: lazyload('UserCenter/pages/Collaboration/JhdReport'),
                    },
                    {
                        path: '/center/collaboration/xsfpreport',
                        element: lazyload('UserCenter/pages/Collaboration/XsfpReport'),
                    },
                    {
                        path: '/center/collaboration/ssflbm',
                        element: lazyload('UserCenter/pages/Collaboration/Ssflbm'),
                    },
                    {
                        path: '/center/collaboration/smjl',
                        element: lazyload('UserCenter/pages/Collaboration/Smjl'),
                    },
                    {
                        path: '/center/collaboration/cxmx',
                        element: lazyload('UserCenter/pages/Collaboration/Cxmx'),
                    },
                    {
                        path: '/center/collaboration/xsngzb',
                        element: lazyload('UserCenter/pages/Collaboration/NewSngzb'),
                    },
                    {
                        path: '/center/collaboration/sngzb',
                        element: lazyload('UserCenter/pages/Collaboration/Sngzb'),
                    },{
                        path: '/center/collaboration/jxssmjlb',
                        element: lazyload('UserCenter/pages/Collaboration/Jxssmjlb'),
                    },
                    {
                        path: '/center/policy/actionnotice',
                        element: lazyload('UserCenter/pages/Policy/ActionNotice'),
                    },
                    {
                        path: '/center/gzt',
                        element: lazyload('Workbench')
                    },
                    {
                        path: '/center/collection',
                        element: lazyload('UserCenter/pages/Collection')
                    },
                    {
                        path: '/center/report/cgxstjb',
                        element: lazyload('UserCenter/pages/Report/Cgxstjb')
                    },
                    {
                        path: '/center/report/cpcgsjfx',
                        element: lazyload('UserCenter/pages/Report/Cpcgsjfx')
                    },
                    {
                        path: '/center/report/cpxssjfx',
                        element: lazyload('UserCenter/pages/Report/Cpxssjfx')
                    },
                    {
                        path: '/center/report/zmjfxsflmx',
                        element: lazyload('UserCenter/pages/Report/Zmjfxsflmx')
                    },
                    {
                        path: '/center/report/zmjfxsflhz',
                        element: lazyload('UserCenter/pages/Report/Zmjfxsflhz')
                    },
                    {
                        path: '/center/report/fzmjfxsflcpmx',
                        element: lazyload('UserCenter/pages/Report/Fzmjfxsflcpmx')
                    },
                    {
                        path: '/center/report/fzmjfxsflhz',
                        element: lazyload('UserCenter/pages/Report/Fzmjfxsflhz')
                    },
                    {
                        path: '/center/report/fzmjfxsjfcx',
                        element: lazyload('UserCenter/pages/Report/Fzmjfxsjfcx')
                    },
                    {
                        path: '/center/report/fxsjfhx',
                        element: lazyload('UserCenter/pages/Report/Fxsjfhx')
                    },
                    {
                        path: '/center/khskd',
                        element: lazyload('UserCenter/pages/ReceiptManage/Khskd'),
                    },
                    {
                        path: '/center/skdzd',
                        element: lazyload('UserCenter/pages/ReceiptManage/Skdzd'),
                    },
                    {
                        path: '/center/qhbb',
                        element: lazyload('UserCenter/pages/Report/Qhbb'),
                    },
                    {
                        path: '/center/base/khlx',
                        element: lazyload('UserCenter/pages/BaseManage/Khlx'),
                    },
                    {
                        path: '/center/report/khxdreport',
                        element: lazyload('UserCenter/pages/Report/Khxdreport'),
                    },
                    {
                        path: '/center/report/Khjhhzreport',
                        element: lazyload('UserCenter/pages/Report/Khjhhzreport'),
                    },
                    {
                        path: '/center/report/wbtzdz',
                        element: lazyload('UserCenter/pages/Link'),
                    },
                    {path: "*", redirect: '/center/fxsorder'}
                ]
            },
            {
                path: '/qpldddrxd/result',
                element: lazyload('UserCenter/pages/Collaboration/Qpldddrxd/Result'),
            },
            {
                path: '/sdgjdddrxd/result',
                element: lazyload('UserCenter/pages/Collaboration/Sdgjdddrxd/Result'),
            },
            {
                path: '/bjmlq',
                element: lazyload('Bjmlq')
            },
            {
                path: '/bjmlq/detail',
                element: lazyload('Bjmlq/Detail')
            },
            {
                path: '/product',
                element: lazyload('Product')
            },
            {
                path: '/product/detail',
                element: lazyload('Product/Detail')
            },
            {
                path: '/dca',
                element: lazyload('Dca')
            },
            {
                path: '/sdcp',
                element: lazyload('Sdcp')
            },
            {
                path: '/sdgjcp',
                element: lazyload('Sdgjcp')
            },
            {
                path: '/allcpxx',
                element: lazyload('AllCpxx')
            },
            {
                path: '/shopcar',
                element: lazyload('ShopCar'),
                children: [
                    {
                        path: '/shopcar',
                        element: lazyload('ShopCar/Step1'),
                    },
                    {
                        path: '/shopcar/confirm',
                        element: lazyload('ShopCar/Step2'),
                    }, {
                        path: '/shopcar/result',
                        element: lazyload('UserCenter/pages/Collaboration/Qpldddrxd/Result'),
                    }, {
                        path: '/shopcar/resultSdgj',
                        element: lazyload('UserCenter/pages/Collaboration/Sdgjdddrxd/Result'),
                    }
                ]
            },
        ]
    },
    {
        path: '/login',
        element: lazyload('Login')
    },
]

const Router = () => {
    return useRoutes(routes)
}

export default Router
